import { useMemo } from 'react';

import { useAuth } from '../../shared/providers/AuthProvider';

import { CollectCapacityReminder } from './domain/collectCapacityReminder/CollectCapacityReminderConfigurator';
import { CollectCapacityReminderProvider } from './domain/collectCapacityReminder/CollectCapacityReminderProvider';
import { useGetAgentWorkload, useGetAgencyCapacityFillingStatus } from './queries';

export const useGetCollectCapacityReminder = (): CollectCapacityReminder | null => {
    const { data: agentWorkload } = useGetAgentWorkload();
    const { data: agencyCapacityFillingStatus } = useGetAgencyCapacityFillingStatus();
    const { isImpersonated } = useAuth();

    return useMemo(() => {
        if (!agentWorkload || !agencyCapacityFillingStatus) {
            return null;
        }

        return new CollectCapacityReminderProvider(
            agentWorkload,
            agencyCapacityFillingStatus,
            isImpersonated,
        ).evaluateNextReminder();
    }, [agentWorkload, agencyCapacityFillingStatus, isImpersonated]);
};
